<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('tab_pane_label_storeBase') || '基本信息'"
        name="storeBase"
        lazy
      >
        <StoreBase
          ref="storeBase"
          :disabled="disabled"
          :amzStoreCode="amzStoreCode"
        />
        <div class="d-flex justify-content-end mb-2 mt-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.storeBase.save()"
            >{{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tab_pane_label_storeSku') || '销售产品'"
        name="storeSku"
        :disabled="!amzStoreCode"
        lazy
      >
        <StoreSku
          ref="storeSku"
          :disabled="disabled"
          :amzStoreCode="amzStoreCode"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import StoreBase from '../components/store-base'
import StoreSku from '../components/sku-table'
export default {
  name: 'ecom-base-awsStore-detail',
  components: { StoreBase, StoreSku },
  data() {
    return { activeName: 'storeBase' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    amzStoreCode() {
      return this.params.code
    },
  },
}
</script>
